import { Link } from "@mui/material";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import React from "react";
import { connect } from "react-redux";
import { selectConstants } from "../../../redux/selectors/firebase";
import { CustomGridColDef } from "../gridColumnDefs";

export interface LinkCellColDef extends CustomGridColDef
{
    onClick: (event: React.MouseEvent<HTMLElement>) => void
}

function LinkCell({ value, formattedValue, colDef }: GridRenderCellParams)
{
    const { onClick } = colDef as unknown as LinkCellColDef;

    return <Link href="#" component={"button"} variant={"body2"} data-value={value} onClick={onClick}>{formattedValue}</Link>
}

const mapStateToProps = (store: never) => ({
    constants: selectConstants(store)
});
export default connect(mapStateToProps, {
})(LinkCell);